import styled, { css } from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, rgba, setFontVariant } from '@similarweb/styles';

import type { InlineAlertVariant } from './InlineAlert';

export const StyledInlineAlert = styled.div<{ variant: InlineAlertVariant; margin?: string }>`
  display: flex;
  width: 100%;
  ${({ variant }) => {
    switch (variant) {
      case 'info':
        return css`
          background-color: ${rgba(colorsPalettes.sky[500], 0.2)};
        `;
      default:
        return '';
    }
  }}
  padding: 6px 8px;
  border-radius: 4px;
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
  ${({ margin }) => margin && `margin: ${margin};`}
  gap: 8px;
`;

export const StyledContentContainer = styled.div`
  text-align: left;
  width: 100%;
`;

export const StyledCloseIcon = styled(SWReactIcons)`
  cursor: pointer;
`;

export const StyledIcon = styled(SWReactIcons)`
  &[data-automation-icon-name='info'] {
    svg path:last-child {
      fill: ${colorsPalettes.carbon[400]};
    }
  }
`;
